module.exports = __webpack_public_path__ + "static/media/Games_Lock@3x.21d0ae20.png";